import "bootstrap/js/src/tab";